var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "全局key-value存储结构"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#全局key-value存储结构"
    }
  }, [_vm._v("#")]), _vm._v(" 全局"), _c('code', [_vm._v("key-value")]), _vm._v("存储结构")]), _vm._v(" "), _c('p', [_vm._v("redis 是一个"), _c('code', [_vm._v("key-value")]), _vm._v("数据库（当然"), _c('code', [_vm._v("value")]), _vm._v("本身也支持很多数据类型），和  java 的 HashMap 一样，内部是使用数组+链表实现的 hash 存储结构。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./00.redis-hash.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "redis-如何解决哈希冲突问题"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#redis-如何解决哈希冲突问题"
    }
  }, [_vm._v("#")]), _vm._v(" redis 如何解决哈希冲突问题")]), _vm._v(" "), _c('p', [_vm._v("随着元素数量增加，哈希冲突的元素会比较多，查询复杂度会从"), _c('code', [_vm._v("O(1)")]), _vm._v("退化成"), _c('code', [_vm._v("O(N)")]), _vm._v("。这时候就需要考虑如何扩容数组数量来减少哈希冲突。")]), _vm._v(" "), _c('p', [_vm._v("redis 对全局哈希表做扩容，称为"), _c('code', [_vm._v("rehash")]), _vm._v("。内部会有两个哈希表，一个用于数据存储（ht[0]），另一个用来扩容（ht[1]）。")]), _vm._v(" "), _c('p', [_vm._v("扩容步骤：")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("为ht[1]分配一个更大的空间")]), _vm._v(" "), _c('li', [_vm._v("将ht[0]数据拷贝到ht[1]")]), _vm._v(" "), _c('li', [_vm._v("释放ht[0]，作为下次"), _c('code', [_vm._v("rehash")]), _vm._v("的扩容哈希表")])]), _vm._v(" "), _c('p', [_vm._v("在第二部迁移数据时，redis 会阻塞用户请求，如果数据量比较大，会影响性能，所以 redis 采用了渐进式迁移方案。")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("次接收用户请求时，就会从ht[0]的数组下标0的位置开始迁移 entry 数据，每次只迁移一部分，避免长时间阻塞用户请求")]), _vm._v(" "), _c('li', [_vm._v("后台线程周期性迁移数据")])]), _vm._v(" "), _c('p', [_vm._v("在"), _c('code', [_vm._v("rehash")]), _vm._v("过程中，查找、删除、更新操作会在两个哈希表进行（双写），新增操作只在ht[1]进行。")]), _vm._v(" "), _c('p', [_vm._v("源码："), _c('a', {
    attrs: {
      "href": "https://github.com/redis/redis/blob/unstable/src/dict.c#L1063",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://github.com/redis/redis/blob/unstable/src/dict.c#L1063"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "参考"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#参考"
    }
  }, [_vm._v("#")]), _vm._v(" 参考")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://tech.meituan.com/2018/07/27/redis-rehash-practice-optimization.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://tech.meituan.com/2018/07/27/redis-rehash-practice-optimization.html"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/doocs/advanced-java/blob/main/docs/high-concurrency/redis-rehash.md",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://github.com/doocs/advanced-java/blob/main/docs/high-concurrency/redis-rehash.md"), _c('OutboundLink')], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };